var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
import { Api } from "../../constants/modules/api.constants";
import { TokenClient } from "../authentication/token-client.service";
import * as Enumerable from "linq";
import { toNative } from "../../utilities/promise-utils";
var InstantGameClientService = /** @class */ (function () {
    function InstantGameClientService(requestClient, tokenClient) {
        this.requestClient = requestClient;
        this.tokenClient = tokenClient;
    }
    InstantGameClientService.prototype.getInstantGameForAdmin = function (request) {
        return toNative(this.requestClient.get(Api.ManageInstantGames.GetForAdmin, request));
    };
    InstantGameClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(Api.ManageInstantGames.Save, {}, request));
    };
    InstantGameClientService.prototype.delete = function (request) {
        return toNative(this.requestClient.post(Api.ManageInstantGames.Delete, {}, request));
    };
    InstantGameClientService.prototype.getInstantGames = function () {
        return toNative(this.requestClient.get(Api.ManageInstantGames.GetAll, {}));
    };
    InstantGameClientService.prototype.getInstantGamesByBrand = function (brandId, instantGameTypeId, getAll) {
        var _this = this;
        if (brandId === void 0) { brandId = null; }
        if (getAll === void 0) { getAll = false; }
        if (getAll || (this.tokenClient.isPreview && !this.tokenClient.user.brandId)) 
        // if is super admin and preview this means there wont be instant games 
        //subscribed since the brandid is null therefor we return all of them
        {
            return new Promise(function (resolve, reject) {
                _this.getInstantGames().then(function (x) {
                    resolve(Enumerable.from(x).select(function (a) {
                        var instantGame = {
                            instantGameId: a.instantGameId,
                            instantGame: a,
                        };
                        return instantGame;
                    }).toArray());
                }, reject);
            });
        }
        else if (this.tokenClient.isPreview && this.tokenClient.user.brandId) {
            return toNative(this.requestClient.get(Api.ManageInstantGames.GetInstantGamesByBrand, { brandId: this.tokenClient.user.brandId, instantGameTypeId: instantGameTypeId }));
        }
        return toNative(this.requestClient.get(Api.ManageInstantGames.GetInstantGamesByBrand, { brandId: brandId, instantGameTypeId: instantGameTypeId }));
    };
    InstantGameClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, TokenClient])
    ], InstantGameClientService);
    return InstantGameClientService;
}());
export { InstantGameClientService };
